import { Box, Button, Center, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type EmptyViewProps = {
  title: string;
  subtitle: string;
  ctaText?: string;
  ctaIcon?: React.ComponentType<{ size?: string | number }>;
  onCtaClick?: () => void;
  customCta?: React.ReactNode;
};

export default function EmptyView({
  title,
  subtitle,
  ctaText,
  ctaIcon: CtaIcon,
  onCtaClick,
  customCta,
}: EmptyViewProps) {
  return (
    <Center mih={400} m="xxl">
      <Stack align="center" gap="sm" maw={512}>
        <Text size="xxl" fw={FONT_WEIGHTS.semibold} c="gray.10" ta="center">
          {title}
        </Text>
        <Text size="md" fw={FONT_WEIGHTS.medium} c="gray.8" ta="center">
          {subtitle}
        </Text>
        <Box mt="xxl">
          {customCta || (
            <Button
              variant="primary"
              size="md"
              leftSection={CtaIcon && <CtaIcon size={16} />}
              onClick={onCtaClick}
            >
              {ctaText}
            </Button>
          )}
        </Box>
      </Stack>
    </Center>
  );
}
